import { Controller } from "stimulus";

let erasIds;
let expansionsIds;
let expansionId;

export default class extends Controller {
  static targets = [
    "erasIds", "expansionsIds", "expansionId", "era", "isFakeDiv",
    "isFake", "code", "releasedAt", "edition", "icon"
  ];


  initialize() {
    erasIds = JSON.parse(this.erasIdsTarget.innerHTML)
    expansionsIds = JSON.parse(this.expansionsIdsTarget.innerHTML)
    expansionId = parseInt(this.expansionIdTarget.innerHTML)
    if (Number.isNaN(expansionId))
      expansionId = null

    super.initialize();
    this.changeEra()
  }

  condition() {
    return this.eraTarget.value &&
      (!erasIds.includes(parseInt(this.eraTarget.value)) || expansionsIds.includes(expansionId))
  }

  changeEra() {
    if (this.condition()) {
      this.isFakeDivTarget.hidden = false;
    }
    else {
      this.isFakeDivTarget.hidden = true;
    }
    this.changeIsFake()
  }

  changeIsFake() {
    this.codeTarget.hidden = this.isFakeTarget.checked || !this.eraTarget.value
    this.releasedAtTarget.hidden = this.isFakeTarget.checked || !this.eraTarget.value
    this.editionTarget.hidden = this.isFakeTarget.checked || !this.eraTarget.value
    this.iconTarget.hidden = this.isFakeTarget.checked || !this.eraTarget.value
  }
}